export const CONTEXT_PATH = '/esignering-web';
